import { PreviewVariant } from '../../../google-templates/preview-common/preview-variant.interface';
import { META_SINGLE_IMAGE_VARIANTS } from '../../meta-single-image-preview/variants/meta-single-image-variants';
// import { MetaVideoVariablesTablePreviewComponent } from './variables-table/variables-table.component';

/**
 * Meta Video Ad preview variants. A video ad runs in the same placements as a
 * single image ad and they lay it out the same way, so it reuses those variant
 * components: each passes `creativeKind` on to `<app-meta-creative>`, which
 * plays the video where the image would be.
 *
 * The first entry is the one the preview opens on.
 */
export const META_VIDEO_VARIANTS: PreviewVariant[] = [
  ...META_SINGLE_IMAGE_VARIANTS,
  // Scaffolding from RCA-478; uncomment to inspect the block -> DTO values.
  // {
  //   id: 'variables-debug',
  //   platform: 'facebook',
  //   device: 'mobile',
  //   label: 'Variables (debug)',
  //   component: MetaVideoVariablesTablePreviewComponent,
  // },
];
